export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4595.1b101e84.jpg";